import { render, staticRenderFns } from "./home.vue?vue&type=template&id=d5f6f1dc&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=d5f6f1dc&lang=scss&scoped=true&"
import style1 from "./home.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f6f1dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5f6f1dc')) {
      api.createRecord('d5f6f1dc', component.options)
    } else {
      api.reload('d5f6f1dc', component.options)
    }
    module.hot.accept("./home.vue?vue&type=template&id=d5f6f1dc&scoped=true&", function () {
      api.rerender('d5f6f1dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/role/home.vue"
export default component.exports